import React from "react";
import { Grid, Tooltip } from "@material-ui/core";
import PropTypes from "prop-types";
import { Stop } from "@material-ui/icons";

const ActionRequiredByOption = (props) => {
  const { name, color } = props;
  return (
    <Grid container justifyContent="space-between" style={{ alignItems: "center" }}>
      <Tooltip title={name}>
        <Grid
          item
          xs
          style={{
            fontSize: 16,
            whiteSpace: "nowrap",
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </Grid>
      </Tooltip>
      <Grid item>
        <Stop style={{ color }} />
      </Grid>
    </Grid>
  );
};

ActionRequiredByOption.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default ActionRequiredByOption;
